export default __webpack_public_path__ + "static/desktop-screen-3ce7d056f31b07d03a9b6737ef273c3a.png";